import(/* webpackMode: "eager" */ "/home/runner/work/lovingnext/lovingnext/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/lovingnext/lovingnext/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/lovingnext/lovingnext/src/app/create/[card-slug]/CreateCardClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/lovingnext/lovingnext/src/components/Faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/lovingnext/lovingnext/src/components/SchemaMarkup.tsx");
